import React, { useState } from 'react'
import { BrowserRouter } from "react-router-dom"
import AppRoutes from './routes/routes';
import NavBar from "./components/navBar"

/*<BrowserRouter basename="/home"> */


function App() {
    return (
        <BrowserRouter>
        
            <AppRoutes />                   
        </BrowserRouter>  
    )
}


export default App
